import { failureFromError, parseApiErrorCode } from '../../lib/api-error';

// The server's Circle link-guard rejects with `groups/contains_outbound_url`
// and carries only a code (DomainError has no message field), so every Circle
// create/edit surface would otherwise show a bare code or a generic failure.
// Map it to user-facing guidance once, here, so create + edit stay consistent.
// In-scope callers pass the translated `linkNotAllowed` (Circles
// `errors.linkNotAllowed`); the English default covers the out-of-scope
// onboarding create-circle step, which stays English by decision.
const LINK_NOT_ALLOWED_EN =
  'Links aren’t allowed in a Circle name or description — message your members or add links to your personal profile instead.';

export function circleSaveErrorMessage(
  err: unknown,
  fallback: string,
  linkNotAllowed: string = LINK_NOT_ALLOWED_EN,
): string {
  if (parseApiErrorCode(err) === 'groups/contains_outbound_url') {
    return linkNotAllowed;
  }
  return failureFromError(err, fallback).message;
}
